import {appendQueryString} from "@pg-mono/request";

/**
 * Creates image links with specified width and height param. Only use with images from S3 bucket. Only some sizes are allowed.
 * Thumbs sizes whitelist: https://git.rynekpierwotny.com/iaac/rynekpierwotny/-/blob/master/files/thumbs-sizes.json
 * @param base - image url
 * @param width - image width
 * @param height - image height
 */
export const getThumbnailLink = (base: string | null | undefined, width?: number, height?: number): string | undefined => {
    if (!base) {
        return undefined;
    }

    return appendQueryString(base, {width, height, format: "auto"});
};
import {appendQueryString} from "@pg-mono/request";

/**
 * Creates image links with specified width and height param. Only use with images from S3 bucket. Only some sizes are allowed.
 * Thumbs sizes whitelist: https://git.rynekpierwotny.com/iaac/rynekpierwotny/-/blob/master/files/thumbs-sizes.json
 * @param base - image url
 * @param width - image width
 * @param height - image height
 */
export const getThumbnailLink = (base: string | null | undefined, width?: number, height?: number): string | undefined => {
    if (!base) {
        return undefined;
    }

    return appendQueryString(base, {width, height, format: "auto"});
};
